import { Button } from "@/components/ui/button";

const previewSymbols = (items) => (Array.isArray(items) ? items : []).slice(0, 3).join(", ");
const formatMarketType = (marketType) => {
  const token = String(marketType || "").trim().toLowerCase();
  if (token === "spot") return "Spot";
  if (token === "futures") return "Futures";
  if (token === "both") return "Both";
  return "-";
};

export const ActiveSymbolScopeCard = ({ scope = {}, onEditScope, onViewAll, onChangeList }) => {
  const symbolCount = Number.isFinite(Number(scope?.selected_symbol_count))
    ? Number(scope.selected_symbol_count)
    : "-";
  const isBothMarket = String(scope?.market_type || "").trim().toLowerCase() === "both";
  const spotCount = Number.isFinite(Number(scope?.spot_symbol_count)) ? Number(scope.spot_symbol_count) : 0;
  const futuresCount = Number.isFinite(Number(scope?.futures_symbol_count)) ? Number(scope.futures_symbol_count) : 0;

  return (
    <article className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="active-symbol-scope-card">
      <h3 className="text-base font-semibold text-slate-900" data-testid="active-symbol-scope-title">Active Symbol Scope</h3>
      <div className="mt-3 grid gap-2 text-sm sm:grid-cols-2" data-testid="active-symbol-scope-content">
        <p data-testid="active-symbol-scope-type">Scope Type: <strong>{scope.selected_scope_type || "-"}</strong></p>
        <p data-testid="active-symbol-scope-market-type">Market: <strong>{formatMarketType(scope.market_type)}</strong></p>
        <p data-testid="active-symbol-scope-list-name">List Name: <strong>{scope.selected_list_name || "-"}</strong></p>
        <p data-testid="active-symbol-scope-count">Symbol Count: <strong>{symbolCount}</strong></p>
        {isBothMarket && <p data-testid="active-symbol-scope-spot-count">Spot Symbols: <strong>{spotCount}</strong></p>}
        {isBothMarket && <p data-testid="active-symbol-scope-futures-count">Futures Symbols: <strong>{futuresCount}</strong></p>}
        {isBothMarket && <p data-testid="active-symbol-scope-total-count">Total Symbols: <strong>{symbolCount}</strong></p>}
        <p data-testid="active-symbol-scope-source">Source: <strong>{scope.source_mode || "-"}</strong></p>
        <p data-testid="active-symbol-scope-updated">Last Updated: <strong>{scope.last_updated || scope.updated_at || "-"}</strong></p>
        <p data-testid="active-symbol-scope-preview">Selected Examples: <strong>{previewSymbols(scope.selected_symbols_preview) || "-"}</strong></p>
      </div>
      <div className="mt-4 flex flex-wrap gap-2" data-testid="active-symbol-scope-actions">
        <Button type="button" variant="outline" onClick={onEditScope} data-testid="active-symbol-scope-edit-button">Scope Düzenle</Button>
        <Button type="button" variant="outline" onClick={onViewAll} data-testid="active-symbol-scope-view-all-button">Tümünü Gör</Button>
        <Button type="button" variant="outline" onClick={onChangeList} data-testid="active-symbol-scope-change-list-button">Listeyi Değiştir</Button>
      </div>
    </article>
  );
};
